import { useEffect, useState } from 'react';

// Small preview of a not-yet-sent image attachment, so students can see what they picked.
export default function AttachmentThumb({ file, className = 'w-10 h-10' }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);

  if (!url) return null;
  return <img src={url} alt="" className={`${className} rounded-md object-cover shrink-0`} />;
}

// Camera photos are named "camera-<timestamp>.jpg" — show a friendly label instead.
export function attachmentLabel(file) {
  return /^camera-\d+\.jpg$/.test(file.name) ? 'Camera photo' : file.name;
}
